import o from"styled-components";import{theme as r}from"../../../theme.js";import{Variants as t}from"./Elo.interface.js";const a=o.div`
  display: grid;
  grid-template-columns: ${({variant:i})=>i===t.row?"592px 1fr":"1fr"};
  grid-template-rows: ${({variant:i})=>i===t.row?"333px":"auto"};
  > img {
    width: 100%;
    height: 300px;
    display: block;
    border-radius: 6px 6px 0 0;
    object-fit: cover;
  }
  @media screen and (max-width: ${r.breakpoints.lg}) {
    grid-template-columns: 1fr;
    grid-template-rows: auto;
    > iframe {
      aspect-ratio: 16/9;
      height: auto !important;
    }
    > img {
      height: unset;
      object-fit: contain;
    }
  }
`,e=o.div`
  padding: ${r.spacing*4}px;
  border-radius: 0 0 6px 6px;
  background-color: ${r.colors.gray[100]};
  display: flex;
  flex-direction: column;
  gap: ${r.spacing*4}px;
  > p {
    color: ${r.colors.gray[900]};
    line-height: 24px;
    margin: 0;
    max-height: 100%;
    overflow-y: auto;
  }
`,p=o.img`
  width: 100%;
  height: 300px;
  display: block;
  border-radius: 6px 6px 0 0;
  object-fit: cover;
`;export{a as Container,p as Picture,e as Wrapper};
